import { render, staticRenderFns } from "./InterfaceSettingsButtons.vue?vue&type=template&id=30fb819c&scoped=true"
import script from "./InterfaceSettingsButtons.vue?vue&type=script&lang=js"
export * from "./InterfaceSettingsButtons.vue?vue&type=script&lang=js"
import style0 from "./InterfaceSettingsButtons.vue?vue&type=style&index=0&id=30fb819c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb819c",
  null
  
)

export default component.exports